import React from "react";
import { motion } from "framer-motion";
import "./WelcomeSection.css";
import teacherstu from '../Assets/teacherstu.png'

const WelcomeSection = () => {
  return (
    <section className="welcome-section">
      <img className="techer" src={teacherstu} alt="texh">
      </img>
      <div className="welcome-container">
        {/* Heading Animation */}
        <motion.h1
          className="welcome-title"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          Welcome to <span>NewZeal Language </span> Academy
        </motion.h1>

        {/* First Paragraph */}
        <motion.p
          className="welcome-text"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.9, delay: 0.3, ease: "easeOut" }}
        >
          At <b>NewZeal Language Academy</b>, we believe that <b>language is the key to confidence and opportunity</b>. Our mission is to empower learners of all backgrounds — <b>homemakers, professionals, entrepreneurs and students</b>—to communicate effectively in English and excel in every aspect of life. <br/><br/>
          We focus on <b>practical, real-life spoken English</b> that goes beyond textbooks. From parent-teacher meetings to workplace presentations, business interactions, and campus conversations, <b>our goal is to help you speak fluently, express clearly, and connect confidently</b> with the world around you.<br/><br/>
        With <b>personalized guidance, simple methods, and a supportive environment</b>, NewZeal Language Academy is more than a language class—it’s a partner in your journey to growth, confidence, and success.<br/><br/>
        With our 100% online classes, you will finding easier to learn from the comfort of your home.
        </motion.p>

        {/* Second Paragraph */}

        {/* Button with hover animation */}
        {/* <motion.button
          className="welcome-btn"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.9 }}
        >
          KNOW MORE
        </motion.button> */}
      </div>
    </section>
  );
};

export default WelcomeSection;
